import { render, staticRenderFns } from "./TaskStepForm.vue?vue&type=template&id=b6c5a2fc"
import script from "./TaskStepForm.vue?vue&type=script&lang=js"
export * from "./TaskStepForm.vue?vue&type=script&lang=js"
import style0 from "./TaskStepForm.vue?vue&type=style&index=0&id=b6c5a2fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports